import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Configura????o do Firebase
const firebaseConfig = {
    apiKey: "AIzaSyDk5G3ZXInN_RMY9BQOz3Qe5sIDiwmje8w",
    authDomain: "otymafarma-dev.firebaseapp.com",
    projectId: "otymafarma-dev",
    storageBucket: "otymafarma-dev.firebasestorage.app",
    messagingSenderId: "45584908779",
    appId: "1:45584908779:web:7f6d53575ac7c4cfcb59ae",
    measurementId: "G-N19EMGEMED"
};

// Inicializa Firebase
let app;
let auth;
let googleProvider;

try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    googleProvider = new GoogleAuthProvider();
} catch (error) {
    console.warn("Firebase n??o inicializado:", error);
}

export { auth, googleProvider };

